import ConfigInfo from './config'
import InterfaceList from './../service'

export default {
    install (Vue) {
        let VuePrototype = Vue.prototype
        // 配置公共信息
        VuePrototype.$configInfo = ConfigInfo
        // 接口
        VuePrototype.$asyncAjax = InterfaceList
    }
}
